import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactTable from 'react-table';
import matchSorter from 'match-sorter';

import TablePagination from 'components/ui/TablePagination';

function GmailCampaignHistoryTable(props) {
  const { data, filtered } = props;

  const percentageNumber = (total, number) => {
    const per = number === 0 ? '0.0' : ((number / total) * 100).toFixed(1);
    return `${number} (${per}%)`;
  };

  if (!data.length) {
    return (
      <div style={{ padding: '30px' }}>
        <h4>Empty data set, select a date range and click load</h4>
      </div>
    );
  }

  return (
    <ReactTable
      PaginationComponent={TablePagination}
      className="-highlight"
      columns={[
        {
          Header: 'cid',
          id: 'csv_id',
          accessor: 'csv_id',
          width: 75,
        },
        {
          Header: 'tid',
          id: 'template_id',
          accessor: 'template_id',
          width: 75,
        },
        {
          Header: 'CSV',
          id: 'csv_name',
          accessor: 'csv_name',
        },
        {
          Header: 'Template Name',
          id: 'template_name',
          accessor: 'template_name',
        },
        {
          Header: 'Total Scheduled',
          id: 'total_scheduled',
          accessor: 'total_scheduled',
          width: 130,
        },
        {
          Header: 'Total Sent',
          id: 'total_sent',
          accessor: d => percentageNumber(d.total_scheduled, d.total_sent),
        },
        {
          Header: 'Total Failed',
          id: 'total_failed',
          accessor: d => percentageNumber(d.total_scheduled, d.total_failed),
        },
        {
          Header: 'Status',
          id: 'status',
          accessor: d =>
            d.total_sent + d.total_failed >= d.total_scheduled
              ? 'Completed'
              : 'Ongoing',
          width: 100,
          style: { textAlign: 'center' },
        },
        {
          Header: 'Created Date',
          id: 'created_at',
          accessor: d => moment(new Date(d.created_at)).format('YYYY-MM-DD'),
        },
        {
          Header: '',
          id: 'all',
          width: 0,
          resizable: false,
          sortable: false,
          show: false,
          Filter: () => {},
          getProps: () => {},
          filterMethod: (filter, rows) => {
            const result = matchSorter(rows, filter.value, {
              keys: [
                'template_name',
                'status',
                'csv_name',
                'template_id',
                'csv_id',
              ],
              threshold: matchSorter.rankings.WORD_STARTS_WITH,
            });
            return result;
          },
          filterAll: true,
        },
      ]}
      data={data}
      defaultPageSize={10}
      filtered={filtered}
      firstText={<i className="material-icons">first_page</i>}
      lastText={<i className="material-icons">last_page</i>}
      minRows={0}
      nextText={<i className="material-icons">chevron_right</i>}
      previousText={<i className="material-icons">chevron_left</i>}
      rowsSelectorText="Rows per page"
      showPageJump={false}
      showPaginationBottom
    />
  );
}

GmailCampaignHistoryTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      createdAt: PropTypes.string,
      createdBy: PropTypes.string,
      totalScheduled: PropTypes.number,
      totalSent: PropTypes.number,
      totalFailed: PropTypes.number,
    }),
  ),
  filtered: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

export default GmailCampaignHistoryTable;
